module.exports = __webpack_public_path__ + "media/src/images/logos/stripe-2f68ae84513a0226f07fa3794733c741.png";